// @flow
import type {Node} from 'react';
import {useNavigate} from 'react-router-dom';
import {Icon, IconNames, GridActionsCellItem} from '@wellstone-solutions/web';
import type {Member} from 'api/v2';

type PropsType = {member: Member, showInMenu: boolean};

export const ViewProfile = ({member, showInMenu}: PropsType): Node => {
  const navigate = useNavigate();

  return (
    <GridActionsCellItem
      label="View profile"
      key="viewProfile"
      icon={<Icon name={IconNames.ProfileCircle} size={22} />}
      showInMenu={showInMenu}
      onClick={() => {
        navigate(`/members/${member.id}`);
      }}
    />
  );
};
